module.exports = __webpack_public_path__ + "static/img/2.2c3a395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/2.png
// module id = 2ayZ
// module chunks = 0